import {
  put, call, takeLatest, fork, all,
} from 'redux-saga/effects';
import { isFunction } from 'lodash';
import {
  FETCH_NOTIFICATIONS, FETCH_USER_NOTIFICATIONS, FETCH_MARKED_NOTIFICATIONS,
  CHECKED_USER_NOTIFICATIONS,
  CHECKED_ALL_USER_NOTIFICATIONS,
  DELETE_ALL_USER_NOTIFICATIONS,
  DELETE_USER_NOTIFICATIONS,
} from '../actions/notification/action_types';
import rf from '../../requests/RequestFactory';
import actions from '../actions/notification';

function* fetchNotifications(action) {
  try {
    const { data, total_count: totalCount } = yield call((params) => rf.getRequest('NotificationRequest').fetchNotifications(params), action.params);
    yield put(actions.fetchNotificationsSucceed(data));
    if (isFunction(action.callback)) {
      yield action.callback({ data, totalCount });
    }
  } catch (err) {
    yield put(actions.fetchNotificationsFailed(err));
  }
}

function* fetchUserNotifications(action) {
  try {
    const { data, total_count: totalCount } = yield call((params) => rf.getRequest('NotificationRequest').fetchUserNotifications(params), action.params);
    yield put(actions.fetchUserNotificationsSucceed(data));
    if (isFunction(action.callback)) {
      yield action.callback({ data, totalCount });
    }
  } catch (err) {
    yield put(actions.fetchUserNotificationsFailed(err));
  }
}

function* fetchMarkedUserNotifications(action) {
  try {
    const { data, total_count: totalCount } = yield call((params) => rf.getRequest('NotificationRequest').fetchMarkedUserNotifications(params), action.params);
    yield put(actions.fetchMarkedNotificationsSucceed(data));
    if (isFunction(action.callback)) {
      yield action.callback({ data, totalCount });
    }
  } catch (err) {
    yield put(actions.fetchMarkedNotificationsFailed(err));
  }
}

function* checkedUserNotification(action) {
  try {
    yield call((params) => rf.getRequest('NotificationRequest').checkedNotification(params), action.params);
    yield put(actions.checkedUserNotificationsSucceed());
  } catch (err) {
    yield put(actions.checkedUserNotificationsFailed(err));
  }
}

function* checkedAllUserNotifications(action) {
  try {
    yield call((params) => rf.getRequest('NotificationRequest').checkedAllNotifications(params), action.params);
    yield put(actions.checkedAllUserNotificationsSucceed());
    if (isFunction(action.callback)) {
      yield action.callback();
    }
  } catch (err) {
    yield put(actions.checkedAllUserNotificationsFailed(err));
  }
}

function* deleteUserNotifications(action) {
  try {
    yield call((params) => rf.getRequest('NotificationRequest').deleteNotification(params), action.params);
    yield put(actions.deleteUserNotificationsSucceed());
  } catch (err) {
    yield put(actions.deleteUserNotificationsFailed(err));
  }
}

function* deleteAllUserNotifications(action) {
  try {
    yield call((params) => rf.getRequest('NotificationRequest').deleteAllNotifications(params), action.params);
    yield put(actions.deleteAllUserNotificationsSucceed());
    if (isFunction(action.callback)) {
      action.callback();
    }
  } catch (err) {
    yield put(actions.deleteAllUserNotificationsFailed(err));
  }
}

function* watchNotifications() {
  yield takeLatest(FETCH_NOTIFICATIONS, fetchNotifications);
  yield takeLatest(FETCH_USER_NOTIFICATIONS, fetchUserNotifications);
  yield takeLatest(CHECKED_USER_NOTIFICATIONS, checkedUserNotification);
  yield takeLatest(CHECKED_ALL_USER_NOTIFICATIONS, checkedAllUserNotifications);
  yield takeLatest(DELETE_USER_NOTIFICATIONS, deleteUserNotifications);
  yield takeLatest(DELETE_ALL_USER_NOTIFICATIONS, deleteAllUserNotifications);
  yield takeLatest(FETCH_MARKED_NOTIFICATIONS, fetchMarkedUserNotifications);
}

export default function* rootSaga() {
  yield all([fork(watchNotifications)]);
}
